export const appendUtmSourceId = (form) => {
    const utmId = sessionStorage.getItem('utm_source');
    if (utmId) {
        const UtmSourceInput = document.createElement('input');
        UtmSourceInput.name = 'utm_source';
        UtmSourceInput.type = 'hidden';
        UtmSourceInput.value = utmId;
        form.appendChild(UtmSourceInput);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/utils/utmUtil.js